export async function withRetry<T>(
    fn: () => Promise<T>,
    retries = 3,
    baseDelayMs = 300,
    signal?: AbortSignal,
): Promise<T> {
    let lastError: unknown;

    for (let attempt = 0; attempt <= retries; attempt++) {
        try {
            const result = await fn();

            if (signal?.aborted) {
                throw new Error(`Retry aborted: ${fn?.name}`);
            }

            if (result instanceof Response && !result.ok && result.status >= 500) {
                throw new Error(`Server error: ${result.status} ${result.statusText}`);
            }

            return result;
        } catch (err) {
            lastError = err;

            if (signal?.aborted) {
                throw new Error(`Retry aborted: ${fn?.name}`);
            }

            if (attempt === retries) break;

            await new Promise((resolve) => setTimeout(resolve, baseDelayMs * 2 ** attempt));
        }
    }

    throw lastError;
}
